var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"section"}},[_c('tb',{attrs:{"t-btxt1":_vm.p1stitle1,"t-btxt2":_vm.p1stitle2,"t-button1":_vm.p1sbutton2,"t-button0":_vm.p1sbutton1,"t-burl":"","tcont":"1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }